import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import theme from './config/theme';
import { stage } from './config';
import GAListener from './components/GAListener';

const stripePromise = loadStripe(
  stage === 'production'
    ? 'pk_live_yufnPEx75HJKUtWJdnWKEnXe00iA14APew'
    : 'pk_test_c6thhds0uYhN0QqgU9S617mg00gsAPhiVv',
);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Elements stripe={stripePromise}>
          <GAListener
            trackingId={
              (window as { __limberGoogleAnalyticsTrackingId?: string })
                .__limberGoogleAnalyticsTrackingId
            }
          />
          <App />
        </Elements>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
